import { useEffect, useState } from "react";
import { Badge, Table } from "reactstrap";
import contratoService from "services/ContratoService";

const acaoCores = {
  CREATE: 'success',
  UPDATE: 'warning',
  DELETE: 'danger',
  PUBLISH: 'info',
};

const acaoLabels = {
  CREATE: 'Criação',
  UPDATE: 'Alteração',
  DELETE: 'Exclusão',
  PUBLISH: 'Publicação',
};

function formatarValor(val) {
  if (val === null || val === undefined) return '—';
  if (typeof val === 'object') return JSON.stringify(val);
  return String(val);
}

function DiffTable({ anterior, novo }) {
  const chaves = new Set([...Object.keys(anterior || {}), ...Object.keys(novo || {})]);
  if (chaves.size === 0) return null;
  return (
    <table className="table table-sm mb-0 mt-1">
      <thead>
        <tr>
          <th>Campo</th>
          <th>Antes</th>
          <th>Depois</th>
        </tr>
      </thead>
      <tbody>
        {[...chaves].map(key => (
          <tr key={key}>
            <td><code>{key}</code></td>
            <td className="text-danger">{formatarValor(anterior?.[key])}</td>
            <td className="text-success">{formatarValor(novo?.[key])}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

function LinhaLog({ log }) {
  const [expandido, setExpandido] = useState(false);
  const temDiff = log.valorAnterior || log.valorNovo;

  return (
    <>
      <tr>
        <td>{new Date(log.data).toLocaleString('pt-BR')}</td>
        <td>
          <Badge color={acaoCores[log.acao] || 'secondary'}>
            {acaoLabels[log.acao] || log.acao}
          </Badge>
        </td>
        <td>{log.usuario?.nome || '—'}</td>
        <td>
          {temDiff && (
            <i
              className={`bi bi-chevron-${expandido ? 'up' : 'down'} custom-button`}
              style={{ cursor: 'pointer' }}
              onClick={() => setExpandido(e => !e)}
            />
          )}
        </td>
      </tr>
      {expandido && temDiff && (
        <tr>
          <td colSpan={4} className="bg-light">
            <DiffTable anterior={log.valorAnterior} novo={log.valorNovo} />
          </td>
        </tr>
      )}
    </>
  );
}

export default function Auditoria({ idContrato }) {
  const [logs, setLogs] = useState([]);
  const [carregando, setCarregando] = useState(false);

  useEffect(() => {
    if (!idContrato) return;
    setCarregando(true);
    contratoService.listarAuditoria(idContrato, 'contrato', idContrato)
      .then(res => {
        if (res.success) setLogs(res.data);
      })
      .catch(() => {})
      .finally(() => setCarregando(false));
  }, [idContrato]);

  return (
    <Table className="align-items-center table-flush" responsive>
      <thead className="thead-light">
        <tr>
          <th>Data</th>
          <th>Ação</th>
          <th>Usuário</th>
          <th style={{ width: 40 }}></th>
        </tr>
      </thead>
      <tbody>
        {carregando && (
          <tr><td colSpan={4} className="text-center py-3">Carregando...</td></tr>
        )}
        {!carregando && logs.length === 0 && (
          <tr><td colSpan={4} className="text-center text-muted py-3">Nenhum registro encontrado</td></tr>
        )}
        {logs.map(log => <LinhaLog key={log.id} log={log} />)}
      </tbody>
    </Table>
  );
}
